import PropTypes from 'prop-types';
import { Component } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FullWidth = styled.div.withConfig({
  displayName: "MessageComposer__FullWidth",
  componentId: "sc-1rt02yu-0"
})(["width:100%;"]);
const InputWrapper = styled.div.withConfig({
  displayName: "MessageComposer__InputWrapper",
  componentId: "sc-1rt02yu-1"
})(["display:flex;width:100%;align-items:center;justify-content:space-between;flex-wrap:nowrap;"]);
export default class MessageComposer extends Component {
  render() {
    const composerClassName = "input-container m-bottom-2" + (!this.props.showingHsBranding ? " no-branding" : "");
    return /*#__PURE__*/_jsxs("div", {
      className: composerClassName,
      children: [this.props.FileUploads && /*#__PURE__*/_jsx(FullWidth, {
        children: this.props.FileUploads
      }), /*#__PURE__*/_jsxs(InputWrapper, {
        children: [this.props.inputToRender, this.props.children && /*#__PURE__*/_jsx("div", {
          className: "display-flex flex-row m-left-1 no-shrink",
          children: this.props.children
        })]
      })]
    });
  }
}
MessageComposer.propTypes = {
  FileUploads: PropTypes.node,
  children: PropTypes.node,
  inputToRender: PropTypes.node.isRequired,
  showingHsBranding: PropTypes.bool
};
MessageComposer.defaultProps = {
  FileUploads: null,
  showingHsBranding: false
};
MessageComposer.displayName = 'MessageComposer';